import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost } from '../../api/client';
import '../../styles/admin.css';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await apiPost('/admin/login', { username, password });
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page admin-login-page">
      <form className="admin-card admin-login-card" onSubmit={handleSubmit}>
        <h1>ZeMaxi CMS</h1>
        <p>Sign in to manage your site content</p>
        {error && <p className="admin-error">{error}</p>}
        <div className="admin-form">
          <label>
            Username
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          </label>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </div>
      </form>
    </div>
  );
}
